import ProductSkuCSP from "../../models/csp/ProductSkuCSP";
import service from "../service";
import baseEndpointPartnerCenter from "./servicePartnerCenter";

export default {
  components: { service: service },
  methods: {
    async getProductSkusCSP(customerId: string): Promise<ProductSkuCSP[]> {
      const response = await service.methods.getEndpointAsync(
        `${baseEndpointPartnerCenter}/customers/${customerId}/subscribedskus`
      );
      return response.items.map(sku => {
        return new ProductSkuCSP({
          productName: sku.productSku.name,
          activeUnits: sku.activeUnits,
          consumedUnits: sku.consumedUnits,
          availableUnits: sku.availableUnits
        });
      });
    }
  }
};
